module.exports = __webpack_public_path__ + "img/56.65731fb7.jpg";